import React from 'react'

import { MetricStats } from '../shared/types'
import { MetricStats as MetricStatsComp } from './components/MetricStats'
import { NO } from './components/NO'
import { Text } from './components/Text'
import { SchemaColumn } from './types'

export interface ComponentData {
  rowIndex: number
  metricStats: { [k: string]: MetricStats }
  value: any
  column: SchemaColumn
}

export enum ComponentType {
  Text = 'text',
  NO = 'no',
  MetricStats = 'metric_stats'
}

export const componentMap: { [t: string]: React.FC<ComponentData> } = {
  [ComponentType.Text]: Text,
  [ComponentType.NO]: NO,
  [ComponentType.MetricStats]: MetricStatsComp
}

export interface ColumnComponent {
  __component__?: React.FC<ComponentData>
}
